import { ReactNode } from "react";
import { Text } from "@merge-api/merge-javascript-shared";
import { X } from "lucide-react";

interface Props {
  title: string;
  subtitle?: ReactNode;
  onClose: () => void;
  footer: ReactNode;
  children: ReactNode;
}

// Right-hand slide-in drawer shell (scrim + panel + head/body/foot), used by the
// conductor editors. The shared design system has no Drawer primitive, so this
// is a small scoped one built on Tailwind.
const ConductorDrawer = ({ title, subtitle, onClose, footer, children }: Props) => (
  <>
    <div className="fixed inset-0 z-40 bg-black/40" onClick={onClose} />
    <aside
      role="dialog"
      aria-label={title}
      className="fixed inset-y-0 right-0 z-50 flex w-[640px] max-w-[92vw] flex-col bg-white shadow-xl"
    >
      <div className="flex items-center justify-between gap-3 border-b border-gray-10 px-6 py-4">
        <div className="min-w-0">
          <Text variant="h5">{title}</Text>
          {subtitle && (
            <Text variant="sm" className="block font-mono text-gray-60">
              {subtitle}
            </Text>
          )}
        </div>
        <button
          onClick={onClose}
          aria-label="Close"
          className="rounded p-1 text-gray-60 hover:bg-gray-10 hover:text-gray-90"
        >
          <X size={18} />
        </button>
      </div>
      <div className="flex-1 overflow-y-auto px-6 py-5">{children}</div>
      <div className="flex items-center justify-between gap-3 border-t border-gray-10 px-6 py-3">
        {footer}
      </div>
    </aside>
  </>
);

export default ConductorDrawer;
